import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useGTMDispatch } from '@elgorditosalsero/react-gtm-hook';
// Send Google Tag Manager Virtual Page View
export var useGtmVpv = function(param) {
    var pageType = param.pageType, pageTitle = param.pageTitle, pageURISuffix = param.pageURISuffix, _param_cancelEvent = param.cancelEvent, cancelEvent = _param_cancelEvent === void 0 ? false : _param_cancelEvent;
    var sendDataToGTM = useGTMDispatch();
    var i18n = useTranslation('main').i18n;
    useEffect(function() {
        var suffixString = pageURISuffix ? "/".concat(pageURISuffix) : '';
        if (!cancelEvent) sendDataToGTM({
            event: 'VPV',
            pageURL: "".concat(window.location.origin).concat(window.location.pathname).concat(suffixString),
            pageDOM: window.location.origin,
            pageURI: "".concat(window.location.pathname).concat(suffixString),
            pageType: pageType,
            pageTitle: pageTitle,
            language: i18n.language
        });
    }, [
        cancelEvent,
        i18n.language,
        pageTitle,
        pageType,
        pageURISuffix,
        sendDataToGTM
    ]);
};
export var useGtmVpvCallback = function() {
    var sendDataToGTM = useGTMDispatch();
    var i18n = useTranslation('main').i18n;
    var sendToGtmVpv = useCallback(function(param) {
        var pageType = param.pageType, pageTitle = param.pageTitle, pageURISuffix = param.pageURISuffix;
        var suffixString = pageURISuffix ? "/".concat(pageURISuffix) : '';
        sendDataToGTM({
            event: 'VPV',
            pageURL: "".concat(window.location.origin).concat(window.location.pathname).concat(suffixString),
            pageDOM: window.location.origin,
            pageURI: "".concat(window.location.pathname).concat(suffixString),
            pageType: pageType,
            pageTitle: pageTitle,
            language: i18n.language
        });
    }, [
        i18n.language,
        sendDataToGTM
    ]);
    return {
        sendToGtmVpv: sendToGtmVpv
    };
};
